import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';

const getFontIcon = (state) =>
    {
        switch(state) {
            case 'Unknown':
                return <FontIcon className="material-icons custom-double-icon-button-gray" >home</FontIcon>;
            case 'No action':
                return <FontIcon className="material-icons custom-double-icon-button-gray" >home</FontIcon>;
            case 'Left message':
                return <FontIcon className="material-icons custom-double-icon-button-gray" >forum</FontIcon>;
            case 'Verified':
                return <FontIcon className="material-icons custom-double-icon-button-green" >home</FontIcon>;
            case 'No response':
                return <FontIcon className="material-icons custom-double-icon-button-red" >call_missed_outgoing</FontIcon>;
            case 'Wrong number':
                return <FontIcon className="material-icons custom-double-icon-button-red" >dialpad</FontIcon>;
            case 'Customer contact not required':
                return <FontIcon className="material-icons custom-double-icon-button-gray" >not_interested</FontIcon>;
            default:
              return <FontIcon className="material-icons custom-double-icon-button-red" >home</FontIcon>;
          }
    };

const HomeVerify = (props) => {

    const {homeVerify, workOrderActions, orderId, hideHomeVerify, techId} = props;

    if(!homeVerify || hideHomeVerify)
    {
        return null;
    }

    const onTouchTap = (e, key) => {
        workOrderActions.setHomeVerifyState(orderId, key);
    };

    const saveHomeVerify = () => {
        if(!homeVerify.get('homeVerifyState') || !homeVerify.get('message'))
            return;

        const homeVerifyRequest = {
            state: homeVerify.get('homeVerifyState'),
            message: homeVerify.get('message'),
            serviceOrder: orderId,
            user_id: techId
        };
        workOrderActions.setHomeVerifyStarted(homeVerifyRequest);
        workOrderActions.setHomeVerifyMessage(orderId, '');
        workOrderActions.setHomeVerifyState(orderId, '');
    };

    const handleChange = (e) => {
        workOrderActions.setHomeVerifyMessage(orderId, e.target.value);
    };

    const miHomeVerified = (<MenuItem
        key="homeVerified"
        onTouchTap={(event) => onTouchTap(event, "Verified")}
        leftIcon={getFontIcon("Verified")}
        primaryText="Home Verified"/>);

    const miLeftMessage = (<MenuItem
        key="leftMessage"
        onTouchTap={(event) => onTouchTap(event, "Left message")}
        leftIcon={getFontIcon("Left message")}
        primaryText="Left Message"/>);

    const miNoResponse = (<MenuItem
        key="miNoResponse"
        onTouchTap={(event) => onTouchTap(event, "No response")}
        leftIcon={getFontIcon("No response")}
        primaryText="No Response"/>);

    const miWrongNumber = (<MenuItem
        key="miWrongNumber"
        onTouchTap={(event) => onTouchTap(event, "Wrong number")}
        leftIcon={getFontIcon("Wrong number")}
        primaryText="Wrong Phone Number"/>);

    const miNotRequired = (<MenuItem
        key="miNotRequired"
        onTouchTap={(event) => onTouchTap(event, "Customer contact not required")}
        leftIcon={getFontIcon("Customer contact not required")}
        primaryText="Not Required"/>);


    const tfValue = homeVerify.get('message');

    const menuItems = [];
    menuItems.push(miHomeVerified);
    menuItems.push(miLeftMessage);
    menuItems.push(miNoResponse);
    menuItems.push(miWrongNumber);
    menuItems.push(miNotRequired);

    let menuButtonState = homeVerify.get('homeVerifyState');
    if(!homeVerify.get('homeVerifyState')) {
        if(!homeVerify.get('loading') && homeVerify.get('details'))
        {
            menuButtonState = 'Verified';
        } else
        {
            menuButtonState = '';
        }
    }
    const menuButton = (
        <IconButton
            tooltip="Home Verify Status"
            id="wow-fst-home-verify-menu">
            {getFontIcon(menuButtonState)}
            <FontIcon className="material-icons custom-double-icon-button-gray">keyboard_arrow_down</FontIcon>
        </IconButton>
    );

    const saveButton = (
        <IconButton
            tooltip="Save Home Verify"
            id="wow-fst-save-home-verify-button"
            onTouchTap={saveHomeVerify}>
            <FontIcon className="material-icons">send</FontIcon>
        </IconButton>
    );

    let state;
    let message;
    if(!homeVerify.get('loading') && homeVerify.get('details'))
    {
        message = homeVerify.getIn(['details', 'message']);
        state = homeVerify.getIn(['details', 'state']);
    } else
    {
        message = 'No home verify events found';
        state = 'Unknown';
    }

    const dvHomeVerified = (<div className="row">
                            <div  className="col s2" style={{marginLeft: 'auto'}}>
                                {getFontIcon(state)}
                            </div>
                            <div  className="col s8">
                                <label style={{color: 'black', marginLeft: '-10px'}}>{message}</label>
                            </div>
                        </div>);

    const lblHomeVerifyState = (!homeVerify.get('loading') && homeVerify.get('details')) ? 'Completed' : 'Not Done';

    return (
        <div className="text-align-left"
            style={{
            paddingTop: '10px',
            paddingLeft: '10px',
            paddingRight: '10px'
        }}>
            <div className="col s12 m12 l12" style={{marginLeft: '-10px', marginBottom: '10px'}}>
                <label>Home Verify</label>
                <label className="right-align">Status: {lblHomeVerifyState}</label>
            </div>

            {dvHomeVerified}

            <div className="row">

                <div className="col s2" style={{marginLeft: '-10px'}}>
                    <IconMenu style={{display: 'inline !important'}} iconButtonElement={menuButton}>
                        {menuItems}
                    </IconMenu>
                </div>

                <div className="col s8">
                    <TextField
                        name="note"
                        fullWidth
                        disabled={false}
                        multiLine={false}
                        hintText="Add Note Here..."
                        onChange={handleChange}
                        value={tfValue}
                        rows={1} />
                </div>

                <div className="col s2">
                    {saveButton}
                </div>
            </div>
        </div>
    );

};

HomeVerify.propTypes = {
    homeVerify: PropTypes.object,
    workOrderActions: PropTypes.object,
    orderId: PropTypes.string,
    hideHomeVerify: PropTypes.bool,
    techId: PropTypes.string
};

export default HomeVerify;



// WEBPACK FOOTER //
// ./src/components/work-order/HomeVerify.js